<div class="container py-4">
  <div class="row justify-content-center">
    <div class="col-md-6 col-lg-5">
      <div class="card shadow-sm border-0">
        <div class="card-header bg-primary text-white">
          <h4 class="mb-0">
            <i class="fa-solid fa-lock me-2"></i>Establecer Nueva Contraseña
          </h4>
        </div>

        <div class="card-body">
          <p class="text-muted mb-4">
            Debes elegir una nueva contraseña antes de continuar.
          </p>

          <form [formGroup]="form" (ngSubmit)="cambiar()">
            <!-- Nueva Contraseña -->
            <div class="mb-3">
              <label for="nuevaPassword" class="form-label">Nueva Contraseña</label>
              <div class="input-group">
                <span class="input-group-text"><i class="fa-solid fa-key"></i></span>
                <input
                  type="password"
                  id="nuevaPassword"
                  class="form-control"
                  formControlName="nuevaPassword"
                  required
                />
              </div>
            </div>

            <!-- Confirmar Contraseña -->
            <div class="mb-3">
              <label for="confirmarPassword" class="form-label">Confirmar Nueva Contraseña</label>
              <div class="input-group">
                <span class="input-group-text"><i class="fa-solid fa-key"></i></span>
                <input
                  type="password"
                  id="confirmarPassword"
                  class="form-control"
                  formControlName="confirmarPassword"
                  required
                />
              </div>
            </div>

            <!-- Botón Guardar -->
            <div class="d-grid">
              <button type="submit" class="btn btn-success">
                <i class="fa-solid fa-check me-2"></i>Guardar Contraseña
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
